export enum MultipleChoiceQuestionAnswerType {
  TEXT = 'TEXT',
  MEDIA = 'MEDIA'
}